<div
  class="umkt-horizontal-stepper"
  role="navigation"
  [attr.aria-label]="ariaLabel"
  [ngClass]="{
    'umkt-horizontal-stepper--full-header': hasFullHeader,
    'umkt-horizontal-stepper--steps-only': isStepsOnly
  }"
>
  <div
    *ngIf="shouldRenderTitle || shouldRenderSubtitle"
    class="umkt-horizontal-stepper__header"
  >
    <h2 *ngIf="shouldRenderTitle" class="umkt-horizontal-stepper__header-title">
      {{ resolvedTitle }}
    </h2>
    <p *ngIf="shouldRenderSubtitle" class="umkt-horizontal-stepper__header-subtitle">
      {{ resolvedSubtitle }}
    </p>
  </div>

  <div class="umkt-horizontal-stepper__track">
    <div
      class="umkt-horizontal-stepper__step"
      *ngFor="let step of resolvedSteps; let i = index; trackBy: trackByStepIndex"
      [ngClass]="{
        'is-completed': isCompleted(i),
        'is-active': isActive(i)
      }"
    >
      <div class="umkt-horizontal-stepper__number">{{ i + 1 }}</div>
      <div class="umkt-horizontal-stepper__content">
        <div class="umkt-horizontal-stepper__title">{{ step.title }}</div>
        <div class="umkt-horizontal-stepper__description">
          {{ step.description }}
        </div>
      </div>
    </div>
  </div>
</div>

